// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ny-1";
export var stateContainer = "_ny-0";